import * as angular from 'angular';

"use strict";

angular.module('DownloadModule', [])

export default 'DownloadModule';
